// @flow
'use strict';

import * as React from 'react';

import type { ICofinsQtde, ICofinsOutr } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type TributoQuantidadeProps = {
  item : ICofinsQtde | ICofinsOutr,
};

export default function TributoQuantidade({ item } : TributoQuantidadeProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="cst" width="25%">CST</ColumnDetalhes>
        <ColumnDetalhes field="qtdVendida" width="25%">Quantidade Vendida</ColumnDetalhes>
        <ColumnDetalhes field="valorAliquota" type="moeda" width="25%">Alíquota da COFINS (em reais)</ColumnDetalhes>
        <ColumnDetalhes field="valor" type="moeda" width="25%">Valor da COFINS</ColumnDetalhes>
      </RowDetalhes>
  );
}
